import type { ReactNode } from 'react';

export const symbol_server_person: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h520q24 0 42 18t18 42v680q0 24-18 42t-42 18h-92q-17.49 0-31.56-9T594-113l-24-49H390l-25 49q-8.37 15-22.44 24-14.07 9-31.56 9h-91Zm0-60h91l25-49q8.37-15 22.44-24 14.07-9 31.56-9h180q17.49 0 31.56 9T624-189l23.73 49H740v-680H220v680Zm119-221h282q7.77 0 13.39-5.61Q640-372.23 640-380q0-51-50.5-69.5T480-468q-59 0-109.5 18.5T320-380q0 7.77 5.61 13.39Q331.23-361 339-361Zm192.5-195.42q21.5-21.42 21.5-51.5t-21.42-51.58q-21.42-21.5-51.5-21.5t-51.58 21.42q-21.5 21.42-21.5 51.5t21.42 51.58q21.42 21.5 51.5 21.5t51.58-21.42ZM480-480Z"
		/>
	</svg>
);
